import type { Match } from 'react-resource-router-next';

import type { StudioRouteContext } from './types';

class PrevPrefetchingRoute {
	prevRouteContext: StudioRouteContext | null = null;

	setPrevRouteContext(route: StudioRouteContext | null) {
		this.prevRouteContext = route;
	}

	isSameRouteMatch(route: StudioRouteContext): boolean {
		return (
			!!this.prevRouteContext &&
			isSameRouteMatch({
				prevContextMatch: this.prevRouteContext.match,
				nextContextMatch: route.match,
			})
		);
	}
}

export const prevPrefetchingRoute = new PrevPrefetchingRoute();

type ObjectToCompare = Record<string, string | null | undefined>;

const isShallowEqual = (o1: ObjectToCompare, o2: ObjectToCompare) => {
	const objKeys1 = Object.keys(o1);
	const objKeys2 = Object.keys(o2);

	if (objKeys1.length !== objKeys2.length) {
		return false;
	}

	return objKeys1.every((key) => o1[key] === o2[key]);
};

export const isSameRouteMatch = ({
	prevContextMatch,
	nextContextMatch,
}: {
	nextContextMatch: Match;
	prevContextMatch: Match;
}) =>
	prevContextMatch.path === nextContextMatch.path &&
	isShallowEqual(prevContextMatch.query, nextContextMatch.query) &&
	isShallowEqual(prevContextMatch.params, nextContextMatch.params);
